import { REQUEST_STATUS } from '../../../../constants/request'
import { getQaSelector } from '../../../../utils/common'
import { Counter, TABLE_VARIANT } from '../../../Counter'
import { DragDropDroppableArea } from '../../../DragDrop'
import { EntityStatus } from '../../../Entity'
import { Skeleton } from '../../../Skeleton'
import Text from '../../../Text'
import { QA_NAME_REQUEST_BOARD_COLUMN } from '../RequestBoard.constants'
import { getRequestBoardColumnDroppableId } from '../RequestBoard.utils'

import { getRequestBoardColumnContent } from './RequestBoardColumn.utils'

import * as styles from './RequestBoardColumn.module.css'

function RequestBoardColumn({ cardProps, column, isDropDisabled, pendingIds }) {
  const { count, hasCountError, isCountLoading, isLoading, status } = column

  return (
    <DragDropDroppableArea
      {...getQaSelector({
        context: status,
        value: QA_NAME_REQUEST_BOARD_COLUMN,
      })}
      className={styles.RequestBoardColumn}
      data={{ status }}
      disabled={isDropDisabled}
      id={getRequestBoardColumnDroppableId(status)}
    >
      <div className={styles.header}>
        <EntityStatus id={status} statuses={REQUEST_STATUS} />
        {isLoading || isCountLoading ? (
          <Skeleton className={styles.skeletonCount} />
        ) : hasCountError ? null : count > 0 ? (
          <Counter count={count} variant={TABLE_VARIANT} />
        ) : (
          <Text className={styles.zeroCount}>{count}</Text>
        )}
      </div>
      <div className={styles.track}>
        {getRequestBoardColumnContent({ cardProps, column, pendingIds })}
      </div>
    </DragDropDroppableArea>
  )
}

export default RequestBoardColumn
